import React, { useContext, useMemo, useReducer, useEffect } from 'react'
import { api } from '../../../services/api';
import toast from 'react-hot-toast'
import { lockedReducer } from '../../Utils/reducers';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import { externalComponent } from '../../AppRoutes';
import EditPedido from './edit';
import { hasPermissions } from '../../Utils/groups';
import './style.css'
import Table2, { TableHook } from '../../Table/indexSec';
import { Box, FormControl, InputLabel, MenuItem, Select, TextField, IconButton } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers'
import ColorButton from '../../Buttons/ColorButton';
import { number2dayweek } from '../../Utils/dayjsptbrhelper';
import dayjs from 'dayjs';
import MegaAutoComplete from '../../Utils/megautocomplete';
import { normalize } from './edit';
import IntegerOnly from '../../Utils/IntegerOnly';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const url = '/novopedido/'
const Permission = ['administrador', 'grupo_administradores', 'admfilial', 'representante', 'funcRepresentante']

export const defaultStatus = {
    'aguardando_liberacao': 'Aguardando Liberação',
    'aguardando_envio': 'Aguardando envio',
    'aguardando_faturamento': 'Aguardando Faturamento',
    'faturado': 'Faturado',
    'cancelado': 'Cancelado',
    'inutilizado': 'Inutilizado'
}

export const submitDelete = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.delete(`${url}${data.id}/`)
    setLoader(false)
    if (res.status === 204) {
        toast.success('Inutilizado com sucesso')
        setState({ deleteRow: false, cancel: false })
        getData()
        return
    }
    toast.error(`Pedido não pôde ser salvo. Motivo: ${res.data}`)

}

export const submitInibeCancelamento = async (data, setState, getData, setLoader) => {
    setLoader(true)
    const res = await api.post(`${url}inibir_cancelamento/${data.id}/`, {status: !data.ignore_cancel})
    setLoader(false)
    if (res.status === 200) {
        toast.success(`Cancelamento ${data.ignore_cancel? "Liberado": "Inibido"} com sucesso.`)
        setState({ inibe_cancelamento: false })
        getData()
        return
    }
    toast.error(`Pedido não pôde ser salvo. Motivo: ${res.data}`)

}


export const loadData = async (setState, permission, setLoader) => {
    if (!permission) {
        toast.error('Você não tem permissão para ver as configurações')
        return
    }
    setLoader(true)
    const requests = [
        api.get('/pedidos_conf/all')
    ]
    const [shipping] = await Promise.all(requests);
    setLoader(false)
    const result = { ready: true }
    if (shipping.status === 200)
        result.configs = Object.fromEntries(shipping.data.map(e => ([e.key, e])))

    setState({ ...result })
}

const columns = (setState, permissions) => {
    return [
        { field: "id", headerName: "Número", flex: 0.3, filterType: "number", valueGetter: ({ value }) => value.toString().padStart(6, '0') },
        { field: "elevor_id", headerName: "Referência Elevor", flex: 0.3, filterType: "number", valueGetter: ({ value }) => value?.toString().padStart(6, '0') },
        { field: "representante", headerName: "Representante", flex: 0.3, filterType: "string", renderCell: ({ row, value }) => row?.dump?.representative?.label || value },
        { field: "filial", headerName: "Filial", flex: 0.3, filterType: "string", renderCell: ({ row, value }) => row?.dump?.branch?.label || value },
        { field: "cliente", headerName: "Cliente", flex: 0.3, filterType: "string", renderCell: ({ row, value }) => row?.dump?.costumer?.data?.nome || value },
        { field: "status", headerName: "Status", flex: 0.3, filterType: "string", renderCell: ({ value }) => defaultStatus[value] },
        { field: "created_at", headerName: "Data Criação", flex: 0.3, filterType: "daterange", renderCell: ({ value }) => dayjs(value).format('DD/MM/YYYY HH:mm') },
        {
            field: 'actions', headerName: 'Ações', filterable: false, width: 100,
            renderCell: (props) => {
                return (
                    <Box >
                        {<IconButton onClick={() => { setState({ editRow: props.row }) }}><EditIcon /></IconButton>}
                        {['', 'aguardando_liberacao', 'aguardando_envio'].includes(props.row.status) && <IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton>}
                    </Box>
                )
            }
        }
    ]
}

const search = async (filters, loadData) => {
    loadData(url + 'pedidos/', {
        filterModel: {
            items: [], customItems: {
                field: filters.field,
                created_at__gte: filters.dataini ? dayjs(filters.dataini).format('YYYY-MM-DD HH:mm') : '',
                created_at__lte: filters.dataend ? dayjs(filters.dataend).format('YYYY-MM-DD HH:mm') : '',
                representante: filters.representante?.id || '',
                cliente: filters.costumer?.id || '',
                filial: filters.branch?.id || '',
                id: filters.id || '',
                status: filters.status || '',
                elevor_id: filters.elevor_id || ''
            }
        }
    })
}

const initialFilterState = {
    dataini: '',
    dataend: '',
    representante: '',
    costumer: '',
    id: '',
    elevor_id: '',
    status: '',
    branch: ''
}

const NovoPedido = () => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        next_number: 0,
        orders: [],
        editRow: null,
        deleteRow: null,
        hideRow: null,
        configs: {},
        ready: false
    })

    const [filters, setFilters] = useReducer(lockedReducer, {
        ...initialFilterState
    })

    useEffect(() => {
        loadData(setState, hasPermissions(Permission), setLoader)
    }, [setLoader])

    const [table, reloadTable] = TableHook()

    const reloadData = () => {
        loadData(setState, hasPermissions(Permission), setLoader)
        reloadTable()
    }

    const setColumns = useMemo(() => columns(setState, Permission), [])

    return (
        <>
            {state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja inutilizar o Pedido ${state.deleteRow.id}?`}
                    handleClose={() => { setState({ deleteRow: null }) }}
                    onConfirm={() => submitDelete(state.deleteRow, setState, reloadData, setLoader)}
                />
            }

            {state.editRow &&
                <EditPedido
                    data={state.editRow}
                    nextOrder={state.next_number}
                    handleClose={() => { setState({ editRow: null }) }}
                    reloadData={reloadData}
                    configs={state.configs}
                />
            }

            <Box className='information-table'>
                <Box sx={{ flex: .15 }} className='nfsentrada-filters'>
                    <Box className='filter-items'>
                        <TextField
                            size='small'
                            label={'Número'}
                            value={filters.id}
                            onChange={({ target }) => setFilters({ id: IntegerOnly(target.value, 0, 999999999, true) })}
                            inputProps={{
                                maxLength: 7
                            }}
                        />
                        <TextField
                            size='small'
                            label={'Referência Elevor'}
                            value={filters.elevor_id}
                            onChange={({ target }) => setFilters({ elevor_id: IntegerOnly(target.value, 0, 999999999, true) })}
                            inputProps={{
                                maxLength: 7
                            }}
                        />
                        <MegaAutoComplete
                            fullWidth={true}
                            value={filters.representante}
                            onChange={(data) => setFilters({ representante: data })}
                            noOptionsText={'Digite para procurar um Representante'}
                            timeoutUrl='/novopedido/representantes/'
                            timeoutParam='label'
                            label='Representante'
                            sx={{ maxWidth: '8rem' }}
                        />
                        <MegaAutoComplete
                            fullWidth={true}
                            value={filters.branch}
                            onChange={(data) => setFilters({ branch: data })}
                            noOptionsText={'Digite para procurar uma Filial'}
                            timeoutUrl='/frete/filiais'
                            timeoutParam='label'
                            label='Filial'
                            sx={{ maxWidth: '8rem' }}
                        />
                        <MegaAutoComplete
                            value={filters.costumer}
                            onChange={(data) => {
                                setFilters({
                                    costumer: data,

                                })
                            }}
                            noOptionsText={'Clientes'}
                            timeoutUrl='/novopedido/clientes/'
                            timeoutParam='label'
                            label='Clientes'
                            replace={{
                                filterOptions: (options, state) => {
                                    const inputValue = normalize(state.inputValue); // Normalize user input
                                    return options.filter((option) =>
                                        normalize(option.label).includes(inputValue)
                                    ); // Filter options ignoring the mask
                                }
                            }}
                        />

                        <FormControl size='small' sx={{ minWidth: '15rem' }}>
                            <InputLabel shrink={true} id='select-for-status-on-pedidos'>Status</InputLabel>
                            <Select
                                label='Status'
                                labelId='select-for-status-on-pedidos'
                                value={filters.status}
                                onChange={({ target }) => setFilters({ status: target.value })}
                                displayEmpty={true}
                            >
                                <MenuItem value=''>*Ativos*</MenuItem>
                                {Object.entries(defaultStatus).map(([key, value]) =>
                                    <MenuItem value={key}>{value}</MenuItem>)}
                            </Select>
                        </FormControl>

                        <DateTimePicker
                            slotProps={{ textField: { size: 'small' } }}
                            label="Dt. Criação inicial"
                            size="small"
                            value={dayjs(filters.dataini)}
                            onChange={(e) => setFilters({ dataini: e.format('YYYY-MM-DD') })}
                            format='DD/MM/YYYY'
                            dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                            sx={{ width: '13rem' }}
                        />
                        <DateTimePicker
                            slotProps={{ textField: { size: 'small' } }}
                            label="Dt. Criação final"
                            size="small"
                            value={dayjs(filters.dataend)}
                            onChange={(e) => setFilters({ dataend: e.format('YYYY-MM-DD') })}
                            format='DD/MM/YYYY'
                            dayOfWeekFormatter={(n) => number2dayweek[n.$W]}
                            sx={{ width: '13rem' }}
                        />
                    </Box>
                    <Box className='filter-buttons'>
                        <ColorButton onClick={() => setFilters(initialFilterState)}>
                            Limpar filtros
                        </ColorButton>
                        <ColorButton onClick={() => { search(filters, (uri, data) => table.reloadData(uri, data)) }}>
                            Localizar
                        </ColorButton>
                    </Box>
                </Box>
                <Box className='user-table'>
                    <Table2
                        rows={state.orders}
                        columns={setColumns}
                        className='contabil-grid'
                        pagination
                        rowHeight={30}
                        density='compact'
                        sx={{ height: '100%' }}
                        toolbar
                        slots={{
                            returnComponent: () => window.backtobase(),
                            addComponent: () => setState({ editRow: {} }),
                            columnComponent: false,
                            filterComponent: false,
                        }}
                        slotProps={
                            {addComponent: {name: 'Novo Pedido', class: 'test', reverse: false}}
                        }
                        getURL={url + 'pedidos/'}
                        updateRows={(orders) => setState({ 'orders': orders })}
                        innerRef={table}
                    />
                </Box>
            </Box>
        </>
    )
}

export default NovoPedido;